'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = function (formatter) {
  var date = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new Date();
  var dd = date.getDate();
  var mm = date.getMonth() + 1;
  var yyyy = date.getFullYear();
  if (dd < 10) {
    dd = '0' + dd;
  }
  if (mm < 10) {
    mm = '0' + mm;
  }
  return formatter({
    dd: dd,
    mm: mm,
    yyyy: yyyy
  });
};